import { render, staticRenderFns } from "./JawEditor.vue?vue&type=template&id=7cac00fa&"
import script from "./JawEditor.vue?vue&type=script&lang=js&"
export * from "./JawEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports